import Layout from '@/layout/index'

/**
 * 注意：子菜单仅在路由子菜单时显示。长度>=1
 *
 * hidden: true                   如果设置为true，则该项将不会显示在侧边栏中（默认为false）
 * alwaysShow: true               如果设置为true，将始终显示根菜单
 *                                如果未设置alwaysShow，则当项目在路线中有多个子项时，
 *                                它将变为嵌套模式，否则不显示根菜单
 * redirect: noRedirect           重定向：noRedirect如果设置noRedirect，则面包屑中不会重定向
 * name:'router-name'             名称：'router-name'名称由＜keep-alive＞使用（必须设置！！！）
 * role:[]                        权限  如果需要区分权限必写，并且为数组格式
 * meta : {
    title: 'title'               侧边栏和面包屑中显示的名称（推荐设置）
    icon: 'svg-name'/'el-icon-x' 侧边栏中显示的图标
    noCache: true                如果设置为true，则不会缓存页面（默认为false）
    breadcrumb: false            如果设置为false，则该项将隐藏在面包屑中（默认为true）
    activeMenu: '/example/list'  如果设置路径，侧边栏将突出显示您设置的路径
  }
 */

var router = [
    {
        path: '/',
        component: Layout,
        redirect: '/',
        name: 'homeView',
        meta: {
            title: 'Home',//标题
            icon: 'dashboard'
        },
        children: [
            {
                path: '/',
                component: () => import('@/views/HomeView'),
                name: 'Dashboard',
                meta: {
                    title: 'Home', icon: 'dashboard'
                }
            }
        ]
    },
    {
        path: '/Genome',
        component: Layout,
        redirect: 'Genome',
        name: 'Genome',
        alwaysShow: true,
        menu: 1,
        meta: {
            title: 'Genome',//标题
            icon: 'genome',//图标
        },
        children: [
            {
                path: '/JBrowse',
                component: () => import('@/views/Genome/jbrowse'),
                name: 'JBrowse',
                meta: { title: 'JBrowse' }
            },
            {
                path: '/Function',
                component: () => import('@/views/Genome/Function'),
                name: 'Function',
                meta: { title: 'Function' }
            },
            {
                path: '/PathwaySearch',
                component: () => import('@/views/Genome/Pathway'),
                name: 'Pathway Search',
                meta: { title: 'Pathway Search' }
            },
            {
                path: '/TransposableElements',
                component: () => import('@/views/Genome/TE'),
                name: 'Transposable Elements',
                meta: { title: 'Transposable Elements' }
            },
            {
                path: '/BLAST',
                component: () => import('@/views/Genome/blast'),
                name: 'BLAST',
                meta: { title: 'BLAST' }
            },
            {
                path: '/Collinearity',
                component: () => import('@/views/index'),
                name: 'Collinearity',
                meta: { title: 'Collinearity' },
                redirect: "/MicroCollinearity",
                children: [
                    {
                        path: '/MicroCollinearity',
                        component: () => import('@/views/Genome/MicroCollinearity'),
                        name: 'MicroCollinearity',
                        meta: { title: 'MicroCollinearity' }
                    },
                    {
                        path: '/MacroCollinearity',
                        component: () => import('@/views/Genome/MacroCollinearity'),
                        name: 'MacroCollinearity',
                        meta: { title: 'MacroCollinearity' }
                    },
                ]
            },

            {
                path: '/Information',
                component: () => import('@/views/Genome/Pan-Genome'),
                name: 'Information',
                meta: { title: 'Information' }
            },
            {
                path: '/GenomeDownloads',
                component: () => import('@/views/Genome/Downloads'),
                name: 'Downloads',
                meta: { title: 'Downloads' }
            },

        ]
    },
    {
        path: '/Plastome',
        component: Layout,
        redirect: 'Plastome',
        name: 'Plastome',
        // component: () => import('@/views/zhongzhinfo/zhongzhiziyuan'),
        alwaysShow: true,
        menu: 4,
        meta: {
            title: 'Plastome',//标题
            icon: 'Plastome',//图标
        },
        children: [
            {
                path: '/Chloroplast',
                component: () => import('@/views/Plastome/Chloroplast'),
                name: 'Chloroplast',
                meta: { title: 'Chloroplast' }
            },
            {
                path: '/Mitochondrial',
                component: () => import('@/views/Plastome/Mitochondrial'),
                name: 'Mitochondrial',
                meta: { title: 'Mitochondrial' }
            }
        ]
    },
    {
        path: '/Variome',
        component: Layout,
        redirect: 'Variome',
        name: 'Variome',
        // component: () => import('@/views/zhongzhinfo/zhongzhiziyuan'),
        alwaysShow: true,
        menu: 4,
        meta: {
            title: 'Variome',//标题
            icon: 'Variome',//图标
        },
        children: [
            {
                path: '/VariomeInformation',
                component: () => import('@/views/Variome/Information'),
                name: 'Information',
                meta: { title: 'Information' }
            },
            {
                path: '/SNP',
                component: () => import('@/views/Variome/SNP'),
                name: 'SNP',
                meta: { title: 'SNP' }
            },
            {
                path: '/SV',
                component: () => import('@/views/Variome/SV'),
                name: 'SV',
                meta: { title: 'SV' }
            },
            /* {
                path: '/ExtractedSequence',
                component: () => import('@/views/Variome/Ex-Seq'),
                name: 'Extraction Sequence',
                meta: { title: 'Extraction Sequence' }
            }, */

            /* {
                path: '/VariationsSearch',
                // component: () => import('@/views/Variome/VariationsSearch'),
                name: 'Variations Search',
                meta: { title: 'Variations Search' }
            }, */
            /* {
                path: '/Population',
                component: () => import('@/views/Variome/Population'),
                name: 'Population',
                meta: { title: 'Population' }
            },
            {
                path: '/SelectionSignal',
                component: () => import('@/views/Variome/fst'),
                name: 'Selection Signal',
                meta: { title: 'Selection Signal' }
            }, */
            {
                path: '/VariomeDownloads',
                component: () => import('@/views/Variome/Downloads'),
                name: 'Downloads',
                meta: { title: 'Downloads' }
            },
            // {
            //     path: '/QTL',
            //     // component: () => import('@/views/Variome/QTL'),
            //     name: 'QTL',
            //     meta: { title: 'QTL' }
            // },
            // {
            //     path: '/GWAS',
            //     // component: () => import('@/views/Variome/GWAS'),
            //     name: 'GWAS',
            //     meta: { title: 'GWAS' }
            // },
        ]
    },
    /* {
        path: '/Phenotype',
        component: Layout,
        redirect: 'Phenotype',
        name: 'Phenotype',
        // component: () => import('@/views/zhongzhinfo/zhongzhiziyuan'),
        alwaysShow: true,
        menu: 4,
        meta: {
            title: 'Phenotype',//标题
            icon: 'Phenotype',//图标
        },
        children: [
            {
                path: '/Phenotype',
                // component: () => import('@/views/Phenotype/Phenotype'),
                name: 'Phenotype',
                meta: { title: 'Phenotype' }
            },
        ]
    }, */
    {
        path: '/Transcriptome',
        component: Layout,
        redirect: 'Transcriptome',
        name: 'Transcriptome',
        // component: () => import('@/views/zhongzhinfo/zhongzhiziyuan'),
        alwaysShow: true,
        menu: 4,
        meta: {
            title: 'Transcriptome',//标题
            icon: 'Transcriptome',//图标
        },
        children: [
            // {
            //     path: '/Quality',
            //     // component: () => import('@/views/Transcriptome/Quality'),
            //     name: 'Quality assessment of sequencing data',
            //     meta: { title: 'Quality assessment of sequencing data' }
            // },
            // {
            //     path: '/Mapping',
            //     // component: () => import('@/views/Transcriptome/Mapping'),
            //     name: 'Mapping',
            //     meta: { title: 'Mapping' }
            // },
            {
                path: '/TranscriptomeInformation',
                component: () => import('@/views/Transcriptome/Information'),
                name: 'Information',
                meta: { title: 'Information' }
            },
            {
                path: '/Co-expression',
                component: () => import('@/views/Tools/Coexpression'),
                name: 'Co-expression network',
                meta: { title: 'Co-expression network' }
            },
            {
                path: '/GeneExpression',
                component: () => import('@/views/Transcriptome/GeneExpression'),
                name: 'Gene Expression',
                meta: { title: 'Gene Expression' }
            },
            {
                path: '/Differential',
                component: () => import('@/views/Transcriptome/Differentialgeneanalysis'),
                name: 'Differential expression analysis',
                meta: { title: 'Differential expression analysis' }
            },
            {
                path: '/WGCNA',
                component: () => import('@/views/Transcriptome/WGCNA'),
                name: 'WGCNA',
                meta: { title: 'WGCNA' }
            },
            /* {
                path: '/HeatmapPlot',
                component: () => import('@/views/Transcriptome/HeatmapPlot'),
                name: 'Heatmap Plot',
                meta: { title: 'Heatmap Plot' }
            }, */
            {
                path: '/TranscriptomeDownloads',
                component: () => import('@/views/Transcriptome/Downloads'),
                name: 'Downloads',
                meta: { title: 'Downloads' }
            },
        ]
    },
    /* {
        path: '/Proteome',
        component: Layout,
        redirect: 'Proteome',
        name: 'Proteome',
        // component: () => import('@/views/zhongzhinfo/zhongzhiziyuan'),
        alwaysShow: true,
        menu: 4,
        meta: {
            title: 'Proteome',//标题
            icon: 'Proteome',//图标
        },
        children: [
            {
                path: '/ProteinExpression',
                // component: () => import('@/views/Proteome/ProteinExpressionLevelResults'),
                name: 'Protein Expression',
                meta: { title: 'Protein Expression' }
            },
            {
                path: '/ProteinDifferences',
                // component: () => import('@/views/Proteome/ProteinDifferentialExpressionResults'),
                name: 'Protein Differences',
                meta: { title: 'Protein Differences' }
            },

            {
                path: '/IPR',
                // component: () => import('@/views/Proteome/IPR'),
                name: 'IPR Enrichment',
                meta: { title: 'IPR Enrichment' }
            },
            {
                path: '/Subcellular',
                // component: () => import('@/views/Proteome/Differential'),
                name: 'Subcellular Localization Analysis of Differential Proteins',
                meta: { title: 'Subcellular Localization Analysis of Differential Proteins' }
            },
            {
                path: '/Network',
                // component: () => import('@/views/Proteome/Differential'),
                name: 'Network',
                meta: { title: 'Network' }
            },
        ]
    }, */
    /* {
        path: '/Metabolome',
        component: Layout,
        redirect: 'Metabolome',
        name: 'Metabolome',
        // component: () => import('@/views/zhongzhinfo/zhongzhiziyuan'),
        alwaysShow: true,
        menu: 4,
        meta: {
            title: 'Metabolome',//标题
            icon: 'Metabolome',//图标
        },
        children: [
            {
                path: '/Supersession',
                // component: () => import('@/views/Metabolome/ProteinExpressionLevelResults'),
                name: 'Supersession',
                meta: { title: 'Supersession' }
            },
            {
                path: '/DataAccusation',
                // component: () => import('@/views/Metabolome/DataAccusation'),
                name: 'Data accusation',
                meta: { title: 'Data accusation' }
            },

            {
                path: '/PathwayAnnotation',
                // component: () => import('@/views/Metabolome/IPR'),
                name: 'Pathway Annotation',
                meta: { title: 'Pathway Annotation' }
            },
            {
                path: '/DiffSearch ',
                // component: () => import('@/views/Metabolome/Differential'),
                name: 'Diff Search',
                meta: { title: 'Diff Search' }
            },
            {
                path: '/DiffAnalysis',
                // component: () => import('@/views/Metabolome/Differential'),
                name: 'Diff Analysis',
                meta: { title: 'Diff Analysis' }
            },
        ]
    }, */
    /* {
        path: '/Epigenetics',
        component: Layout,
        redirect: 'Epigenetics',
        name: 'Epigenetics',
        // component: () => import('@/views/zhongzhinfo/zhongzhiziyuan'),
        alwaysShow: true,
        menu: 4,
        meta: {
            title: 'Epigenetics',//标题
            icon: 'Epigenetics',//图标
        },
        children: [
            {
                path: '/Epigenetics',
                // component: () => import('@/views/Epigenetics/Epigenetics'),
                name: 'Epigenetics',
                meta: { title: 'Epigenetics' }
            },
        ]
    }, */
    {
        path: '/toolsView',
        component: Layout,
        redirect: 'Blast',
        name: 'toolsView',
        alwaysShow: true,
        meta: {
            title: 'Tools',//标题
            icon: 'tools'//图标
        },
        children: [

            {
                path: '/Sequence',
                component: () => import('@/views/Tools/Sequence'),
                name: 'Sequence Fetch',
                meta: { title: 'Sequence Fetch' }
            },
            {
                path: '/Enrichment',
                component: () => import('@/views/Tools/Enrichment'),
                name: 'GO & KEGG Enrichment',
                meta: { title: 'GO & KEGG Enrichment' }
            },

            /* {
                path: '/Differentialgeneanalysis',
                // component: () => import('@/views/Tools/Enrichment'),
                name: 'Differential gene analysis',
                meta: { title: 'Differential gene analysis' }
            }, */
            /* {
                path: '/PhylogeneticAnalysis',
                component: () => import('@/views/Tools/PhylogeneticTreeAnalysis'),
                name: 'Phylogenetic analysis',
                meta: { title: 'Phylogenetic analysis' }
            }, */



            /* {
                path: '/Pan-Genome',
                // component: () => import('@/views/Tools/Enrichment'),
                name: 'Pan-Genome',
                meta: { title: 'Pan-Genome' }
            }, */
            /* {
                path: '/MSA',
                component: () => import('@/views/Tools/MSA'),
                name: 'Multiple Sequence Alignment',
                meta: { title: 'Multiple Sequence Alignment' }
            }, */

            {
                path: '/VennPlot',
                component: () => import('@/views/Tools/Venn'),
                name: 'Venn Plot',
                meta: { title: 'Venn Plot' }
            },
            {
                path: '/KaKsCalculation',
                component: () => import('@/views/Tools/KaKsCalculation'),
                name: 'KaKs calculation',
                meta: { title: 'KaKs calculation' }
            },
            {
                path: '/Ortholog-Search',
                component: () => import('@/views/Tools/id-convert'),
                name: 'Ortholog Search',
                meta: { title: 'Ortholog Search' }
            },

        ]
    },
    /* {
        path: '/Germplasm',
        component: Layout,
        redirect: 'Germplasm',
        name: 'Germplasm',
        // component: () => import('@/views/zhongzhinfo/zhongzhiziyuan'),
        alwaysShow: true,
        menu: 4,
        meta: {
            title: 'Germplasm',//标题
            icon: 'Germplasm',//图标
        },
        children: [
            {
                path: '/Germplasm',
                // component: () => import('@/views/Germplasm/Epigenetics'),
                name: 'Statistics of germplasm resource varieties/strains information',
                meta: { title: 'Statistics of germplasm resource varieties/strains information' }
            },
            {
                path: '/Germplasm',
                // component: () => import('@/views/Germplasm/Epigenetics'),
                name: 'Phenotypic data query and statistical analysis',
                meta: { title: 'Phenotypic data query and statistical analysis' }
            },
            {
                path: '/Germplasm',
                // component: () => import('@/views/Germplasm/Epigenetics'),
                name: 'SNP',
                meta: { title: 'SNP' }
            },
            {
                path: '/Germplasm',
                // component: () => import('@/views/Germplasm/Epigenetics'),
                name: 'Consistent sequence extraction',
                meta: { title: 'Consistent sequence extraction' }
            },
            {
                path: '/Germplasm',
                // component: () => import('@/views/Germplasm/Epigenetics'),
                name: 'Fingerprint spectrum display',
                meta: { title: 'Fingerprint spectrum display' }
            },
            {
                path: '/Germplasm',
                // component: () => import('@/views/Germplasm/Epigenetics'),
                name: 'Genealogy Relationship Management Display',
                meta: { title: 'Genealogy Relationship Management Display' }
            },
        ]
    }, */
    /*  {
         path: '/Multiomics',
         component: Layout,
         redirect: 'Multiomics',
         name: 'Multiomics',
         // component: () => import('@/views/zhongzhinfo/zhongzhiziyuan'),
         alwaysShow: true,
         menu: 4,
         meta: {
             title: 'Multiomics',//标题
             icon: 'Multiomics',//图标
         },
         children: [
             {
                 path: '/GenomeInfo',
                 // component: () => import('@/views/Multiomics/Epigenetics'),
                 name: 'Genome Info',
                 meta: { title: 'Genome Info' }
             },
             {
                 path: '/GeneticDiversity',
                 // component: () => import('@/views/Multiomics/Epigenetics'),
                 name: 'Genetic diversity',
                 meta: { title: 'Genetic diversity' }
             },
             {
                 path: '/TraitMapping',
                 // component: () => import('@/views/Multiomics/Epigenetics'),
                 name: 'Trait mapping',
                 meta: { title: 'Trait mapping' }
             },
             {
                 path: '/SuperiorAllele',
                 // component: () => import('@/views/Multiomics/Epigenetics'),
                 name: 'Superior allele',
                 meta: { title: 'Superior allele' }
             },
             {
                 path: '/Multiomics',
                 // component: () => import('@/views/Multiomics/Epigenetics'),
                 name: 'Multi omics analysis tools',
                 meta: { title: 'Multi omics analysis tools' }
             },
         ]
     }, */
    {
        path: '/README',
        component: Layout,
        redirect: '/README',
        name: 'README',
        hidden: true,
        alwaysShow: false,
        meta: { title: 'WalDB Manual' },
        children: [
            {
                path: '/README',
                component: () => import('@/views/README'),
                name: 'READMEContent',
                meta: { title: 'WalDB Manual' }
            }
        ]
    },
    {
        path: '/detail',
        component: Layout,
        redirect: 'detail',
        name: 'detail',
        // component: () => import('@/views/zhongzhinfo/zhongzhiziyuan'),
        alwaysShow: false,
        hidden: true,
        menu: 4,
        meta: {
            title: 'detail',//标题
            icon: 'detail',//图标
        },
        children: [
            {
                path: '/PanGenome',
                component: () => import('@/views/detail/PanGenome'),
                name: 'PanGenome',
                meta: { title: 'PanGenome' }
            },
            {
                path: '/genusInfo',
                component: () => import('@/views/genusInfo'),
                name: 'genusInfo',
                meta: { title: 'genusInfo' }
            },
            {
                path: '/contact',
                component: () => import('@/views/contact'),
                name: 'contact',
                meta: { title: 'contact' }
            },
            {
                path: '/dataDetail',
                component: () => import('@/views/Variome/dataDetail'),
                name: 'dataDetail',
                meta: { title: 'dataDetail' }
            },
            {
                path: '/TranscriptomeDataDetail',
                component: () => import('@/views/Transcriptome/dataDetail'),
                name: 'dataDetail',
                meta: { title: 'dataDetail' }
            },
        ]
    },
]
export default router